export default class incidenciaService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/estado_equipo',
			"id": '/api/estado_equipo/:id',
			"new": '/api/estado_equipo',
			'delete': '/api/estado_equipo/:id'
		};
	}

	getAll(){
		let url = this.baseUrl + this.routes.all;
		return this.http.get(url);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

	destruct(objId){
		let url = this.baseUrl + this.routes.delete;
		let idRoute = this.routes.delete.replace(':id', objId);
		this.http.delete();
	}
}



// WEBPACK FOOTER //
// ./app/js/services/estadoEquipoService.js